<app-header></app-header>
<div class="container mb-sm-3 py-5">
  <div class="error-container text-center">
    <img src="../../../../assets/images/error-404.png" alt="404 Image" class="error-image mb-4">
    <p>Oops! The page you're looking for doesn't exist.</p>
    <a role="button" href="/" class="btn btn-danger text-white mt-3">Go to Homepage</a>
  </div>
</div>
<app-footer></app-footer>
